webpackJsonp([1],Array(25).concat([
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(8);

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__(110);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _Sessions = __webpack_require__(102);

var _Sessions2 = _interopRequireDefault(_Sessions);

var _Session = __webpack_require__(101);

var _Session2 = _interopRequireDefault(_Session);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueRouter2.default);

exports.default = new _vueRouter2.default({
  routes: [{ path: '/', name: 'Sessions', component: _Sessions2.default }, { name: 'new-session', path: '/sessions/new', component: _Session2.default }]
});

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchSessions = fetchSessions;
exports.fetchSessionsSuccess = fetchSessionsSuccess;
exports.fetchSessionsError = fetchSessionsError;
var FETCH_SESSIONS = exports.FETCH_SESSIONS = 'FETCH_SESSIONS';
var FETCH_SESSIONS_SUCCESS = exports.FETCH_SESSIONS_SUCCESS = 'FETCH_SESSIONS_SUCCESS';
var FETCH_SESSIONS_ERROR = exports.FETCH_SESSIONS_ERROR = 'FETCH_SESSIONS_ERROR';

function fetchSessions(state) {
  state.loading = true;
  state.error = '';
  state.sessions = [];
}

function fetchSessionsSuccess(state, sessions) {
  state.error = '';
  state.loading = false;
  state.sessions = sessions;
}

function fetchSessionsError(state, error) {
  state.loading = false;
  state.error = error.toString();
}

/***/ }),
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(95)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(43),
  /* template */
  __webpack_require__(109),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

exports.default = {
	name: 'SweetModal',

	props: {
		title: {
			type: String,
			required: false,
			default: ''
		},

		overlayTheme: {
			type: String,
			required: false,
			default: 'light'
		},

		modalTheme: {
			type: String,
			required: false,
			default: 'light'
		},

		blocking: {
			type: Boolean,
			required: false,
			default: false
		},

		icon: {
			type: String,
			required: false,
			default: ''
		},

		hideCloseButton: {
			type: Boolean,
			required: false,
			default: false
		}
	},

	mounted: function mounted() {
		this.tabs = this.$children.filter(function (c) {
			return c.cmpName && c.cmpName == 'tab';
		});

		if (this.has_tabs) {
			this.currentTab = this._changeTab(this.tabs[0]);
		}

		document.addEventListener('keyup', this._onDocumentKeyup);
	},
	beforeDestroy: function beforeDestroy() {
		document.removeEventListener('keyup', this._onDocumentKeyup);
	},
	data: function data() {
		return {
			visible: false,
			is_open: false,
			is_bouncing: false,
			tabs: []
		};
	},


	computed: {
		has_title: function has_title() {
			return this.title || this.$slots.title;
		},
		has_tabs: function has_tabs() {
			return this.tabs.length > 0;
		},
		has_content: function has_content() {
			return this.$slots.default;
		},
		current_tab: function current_tab() {
			return this.tabs.filter(function (t) {
				return t.active === true;
			})[0];
		},
		overlay_classes: function overlay_classes() {
			return ['sweet-modal-overlay', 'theme-' + this.overlayTheme, 'sweet-modal-clickable', {
				'is-visible': this.visible,
				blocking: this.blocking
			}];
		},
		modal_classes: function modal_classes() {
			return ['sweet-modal', 'theme-' + this.modalTheme, {
				'has-title': this.has_title,
				'has-tabs': this.has_tabs,
				'has-content': this.has_content,
				'has-icon': this.icon,
				'is-visible': this.visible,
				'sweet-alert': this.icon && !this.has_tabs || !this.icon && !this.title && !this.$slots.title,
				bounce: this.is_bouncing
			}];
		}
	},

	methods: {
		open: function open() {
			var _this = this;

			this.is_open = true;
			this._animateIcon();

			setTimeout(function () {
				return _this.visible = true;
			}, 30);
			this.$emit('open');
		},
		close: function close() {
			var _this2 = this;

			this.visible = false;

			setTimeout(function () {
				return _this2.is_open = false;
			}, 300);
			this.$emit('close');
		},
		bounce: function bounce() {
			var _this3 = this;

			this.is_bouncing = true;

			setTimeout(function () {
				return _this3.is_bouncing = false;
			}, 330);
		},
		_onOverlayClick: function _onOverlayClick(event) {
			if (!event.target.classList || event.target.classList.contains('sweet-modal-clickable')) {
				if (this.blocking) {
					this.bounce();
				} else {
					this.close();
				}
			}
		},
		_onDocumentKeyup: function _onDocumentKeyup(event) {
			if (event.keyCode == 27) {
				if (this.blocking) {
					this.bounce();
				} else {
					this.close();
				}
			}
		},
		_changeTab: function _changeTab(tab) {
			this.tabs.map(function (t) {
				return t.active = t == tab;
			});
			this.currentTab = tab;
		},
		_getClassesForTab: function _getClassesForTab(tab) {
			return ['sweet-modal-tab', {
				active: tab.active,
				disabled: tab.disabled
			}];
		},
		_animateIcon: function _animateIcon() {
			var _this4 = this;

			if (!this.icon) return;

			switch (this.icon) {
				case 'success':
					setTimeout(function () {
						_this4._applyClasses(_this4.$refs.icon_success, {
							'': ['animate'],
							'.sweet-modal-tip': ['animateSuccessTip'],
							'.sweet-modal-long': ['animateSuccessLong']
						});
					}, 80);

					break;

				case 'warning':
					this._applyClasses(this.$refs.icon_warning, {
						'': ['pulseWarning'],
						'.sweet-modal-body': ['pulseWarningIns'],
						'.sweet-modal-dot': ['pulseWarningIns']
					});

					break;

				case 'error':
					setTimeout(function () {
						_this4._applyClasses(_this4.$refs.icon_error, {
							'': ['animateErrorIcon'],
							'.sweet-modal-x-mark': ['animateXMark']
						});
					}, 80);

					break;
			}
		},
		_applyClasses: function _applyClasses($ref, classMap) {
			for (var cl in classMap) {
				var _$el$classList, _$el$classList2;

				var classes = classMap[cl];
				var $el = void 0;

				if (cl == '') {
					$el = $ref;
				} else {
					$el = $ref.querySelector(cl);
				}

				(_$el$classList = $el.classList).remove.apply(_$el$classList, _toConsumableArray(classes));
				(_$el$classList2 = $el.classList).add.apply(_$el$classList2, _toConsumableArray(classes));
			}
		}
	}
};

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	props: {
		title: {
			type: String,
			required: true
		},

		id: {
			type: String,
			required: true
		},

		icon: {
			type: String,
			required: false,
			default: null
		},

		disabled: {
			type: Boolean,
			required: false,
			default: false
		}
	},

	data: function data() {
		return {
			active: false
		};
	},


	computed: {
		cmpName: function cmpName() {
			return 'tab';
		}
	}
};

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(8);

var _vue2 = _interopRequireDefault(_vue);

var _vuexRouterSync = __webpack_require__(112);

var _sweetModalVue = __webpack_require__(96);

var _store = __webpack_require__(51);

var _router = __webpack_require__(25);

var _router2 = _interopRequireDefault(_router);

var _Spinner = __webpack_require__(100);

var _Spinner2 = _interopRequireDefault(_Spinner);

var _ErrorModal = __webpack_require__(99);

var _ErrorModal2 = _interopRequireDefault(_ErrorModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('spinner', _Spinner2.default);
_vue2.default.component('error-modal', _ErrorModal2.default);
_vue2.default.component('sweet-modal', _sweetModalVue.SweetModal);

(0, _vuexRouterSync.sync)(_store.store, _router2.default);

exports.default = {
  name: 'app',
  store: _store.store
};

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(15);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(14);

var Vuex = _interopRequireWildcard(_vuex);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'error-modal',
  computed: (0, _extends3.default)({}, Vuex.mapGetters(['error'])),
  updated: function updated() {
    if (this.error) this.$refs.modal.open();
  }
};

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(15);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(14);

var Vuex = _interopRequireWildcard(_vuex);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'spinner',
  computed: (0, _extends3.default)({}, Vuex.mapGetters(['loading']))
};

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'session'
};

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(15);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(14);

var Vuex = _interopRequireWildcard(_vuex);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'sessions',
  methods: (0, _extends3.default)({}, Vuex.mapActions(['retrieveSessions']), {
    openSessionDetail: function openSessionDetail(sessionId) {
      return alert('Session ' + sessionId.toString() + ' clicked');
    }
  }),
  computed: (0, _extends3.default)({}, Vuex.mapGetters(['loading', 'sessions', 'error'])),
  created: function created() {
    this.retrieveSessions();
  }
};

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(8);

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__(40);

var _App2 = _interopRequireDefault(_App);

var _index = __webpack_require__(25);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.config.productionTip = false;

new _vue2.default({
  el: '#app',
  router: _index2.default,
  template: '<App/>',
  components: { App: _App2.default }
});

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(53);

var _promise2 = _interopRequireDefault(_promise);

exports.default = buildSessionsApi;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fakeSessions = [{
  id: 1,
  title: 'User story mapping',
  description: 'Bring your post-its',
  facilitator: 'Mike Smith',
  place: 'Parrot room',
  datetime: 'Today at 6 PM'
}, {
  id: 2,
  title: 'BDD',
  description: 'Beer Driven Development',
  facilitator: 'Jessica Oliver',
  place: 'Bar',
  datetime: 'Tomorrow at 12 AM'
}];

function retrieveSessions() {
  return new _promise2.default(function (resolve, reject) {
    setTimeout(function () {
      var probability = Math.random();
      if (probability < 0.6) resolve(fakeSessions);else reject('Connection problem');
    }, 1000);
  });
}

function buildSessionsApi() {
  return { retrieveSessions: retrieveSessions };
}

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.retrieveSessionsAction = retrieveSessionsAction;
exports.buildRetrieveSessionsAction = buildRetrieveSessionsAction;

var _sessionsApiService = __webpack_require__(49);

var _sessionsApiService2 = _interopRequireDefault(_sessionsApiService);

var _mutations = __webpack_require__(26);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function retrieveSessionsAction(sessionsApi) {
  function run(_ref) {
    var commit = _ref.commit;

    commit(_mutations.FETCH_SESSIONS);

    sessionsApi.retrieveSessions().then(function (sessions) {
      commit(_mutations.FETCH_SESSIONS_SUCCESS, sessions);
    }, function (error) {
      commit(_mutations.FETCH_SESSIONS_ERROR, error);
    });
  }
  return { run: run };
}

function buildRetrieveSessionsAction() {
  return retrieveSessionsAction((0, _sessionsApiService2.default)()).run;
}

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.store = undefined;

var _vue = __webpack_require__(8);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(14);

var _vuex2 = _interopRequireDefault(_vuex);

var _actions = __webpack_require__(50);

var _mutations = __webpack_require__(26);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.config.debug = true;
_vue2.default.use(_vuex2.default);

var initialState = {
  sessions: [],
  loading: false,
  error: ''
};

var store = exports.store = new _vuex2.default.Store({
  state: initialState,
  mutations: {
    FETCH_SESSIONS: _mutations.fetchSessions,
    FETCH_SESSIONS_SUCCESS: _mutations.fetchSessionsSuccess,
    FETCH_SESSIONS_ERROR: _mutations.fetchSessionsError
  },
  actions: {
    retrieveSessions: (0, _actions.buildRetrieveSessionsAction)()
  },
  getters: {
    sessions: function sessions(state) {
      return state.sessions;
    },
    loading: function loading(state) {
      return state.loading;
    },
    error: function error(state) {
      return state.error;
    }
  }
});

/***/ }),
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 90 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 91 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 92 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 93 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 94 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 95 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 96 */,
/* 97 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(91)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(41),
  /* template */
  __webpack_require__(105),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(90)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(42),
  /* template */
  __webpack_require__(104),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(93)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(44),
  /* template */
  __webpack_require__(107),
  /* scopeId */
  "data-v-6a4bf29c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(92)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(45),
  /* template */
  __webpack_require__(106),
  /* scopeId */
  "data-v-69dcc8dc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(89)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(46),
  /* template */
  __webpack_require__(103),
  /* scopeId */
  "data-v-099141ee",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(94)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(47),
  /* template */
  __webpack_require__(108),
  /* scopeId */
  "data-v-6f60233a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 103 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content-panel__header"
  }, [_c('h2', [_vm._v(" New Session  ")])]), _vm._v(" "), _c('p', [_vm._v("Here we'll have a validated form to create new sessions (You'll have to wait for the next post)")])])
}]}

/***/ }),
/* 104 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['sweet-modal-tab', {
      active: _vm.active
    }]
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 105 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.is_open),
      expression: "is_open"
    }],
    class: _vm.overlay_classes,
    on: {
      "click": _vm._onOverlayClick
    }
  }, [_c('div', {
    class: _vm.modal_classes
  }, [_c('div', {
    staticClass: "sweet-box-actions"
  }, [_vm._t("box-action"), _vm._v(" "), (!_vm.hideCloseButton) ? _c('div', {
    staticClass: "sweet-action-close",
    on: {
      "click": _vm.close
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z",
      "fill": "#292c34"
    }
  })])]) : _vm._e()], 2), _vm._v(" "), (_vm.has_title || _vm.has_tabs) ? _c('div', {
    staticClass: "sweet-title"
  }, [(_vm.has_tabs && !_vm.has_title) ? [_c('ul', {
    staticClass: "sweet-modal-tabs"
  }, _vm._l((_vm.tabs), function(tab) {
    return _c('li', {
      class: _vm._getClassesForTab(tab)
    }, [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm._changeTab(tab)
        }
      }
    }, [_c('div', {
      staticClass: "sweet-modal-valign"
    }, [(tab.icon) ? _c('span', {
      staticClass: "sweet-modal-tab-icon",
      domProps: {
        "innerHTML": _vm._s(tab.icon)
      }
    }) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "sweet-modal-tab-title"
    }, [_vm._v(_vm._s(tab.title))])])])])
  }))] : _vm._e(), _vm._v(" "), (_vm.has_title) ? [(_vm.title) ? _c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("title")] : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.has_title && _vm.has_tabs) ? _c('ul', {
    staticClass: "sweet-modal-tabs"
  }, _vm._l((_vm.tabs), function(tab) {
    return _c('li', {
      class: _vm._getClassesForTab(tab)
    }, [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm._changeTab(tab)
        }
      }
    }, [_c('div', {
      staticClass: "sweet-modal-valign"
    }, [(tab.icon) ? _c('span', {
      staticClass: "sweet-modal-tab-icon",
      domProps: {
        "innerHTML": _vm._s(tab.icon)
      }
    }) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "sweet-modal-tab-title"
    }, [_vm._v(_vm._s(tab.title))])])])])
  })) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "content",
    staticClass: "sweet-content"
  }, [(_vm.icon == 'error') ? _c('div', {
    ref: "icon_error",
    staticClass: "sweet-modal-icon sweet-modal-error"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.icon == 'warning') ? _c('div', {
    ref: "icon_warning",
    staticClass: "sweet-modal-icon sweet-modal-warning"
  }, [_c('span', {
    staticClass: "sweet-modal-body"
  }), _vm._v(" "), _c('span', {
    staticClass: "sweet-modal-dot"
  })]) : _vm._e(), _vm._v(" "), (_vm.icon == 'info') ? _c('div', {
    ref: "icon_info",
    staticClass: "sweet-modal-icon sweet-modal-info"
  }) : _vm._e(), _vm._v(" "), (_vm.icon == 'success') ? _c('div', {
    ref: "icon_success",
    staticClass: "sweet-modal-icon sweet-modal-success"
  }, [_c('span', {
    staticClass: "sweet-modal-line sweet-modal-tip"
  }), _vm._v(" "), _c('span', {
    staticClass: "sweet-modal-line sweet-modal-long"
  }), _vm._v(" "), _c('div', {
    staticClass: "sweet-modal-placeholder"
  }), _vm._v(" "), _c('div', {
    staticClass: "sweet-modal-fix"
  })]) : _vm._e(), _vm._v(" "), (_vm.$slots.default) ? _c('div', {
    staticClass: "sweet-content-content"
  }, [_vm._t("default")], 2) : _vm._e()]), _vm._v(" "), (_vm.$slots.button) ? _c('div', {
    staticClass: "sweet-buttons"
  }, [_vm._t("button")], 2) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "sweet-modal-x-mark"
  }, [_c('span', {
    staticClass: "sweet-modal-line sweet-modal-left"
  }), _vm._v(" "), _c('span', {
    staticClass: "sweet-modal-line sweet-modal-right"
  })])
}]}

/***/ }),
/* 106 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loading) ? _c('div', {
    staticClass: "session-list__loader animated fadeIn"
  }, [_vm._m(0)]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loader-inner ball-pulse"
  }, [_c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div')])
}]}

/***/ }),
/* 107 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('sweet-modal', {
    ref: "modal",
    attrs: {
      "icon": "error",
      "title": "Server Fake Error"
    }
  }, [_vm._v(_vm._s(_vm.error) + " (Refresh until you get the sessions)\n")])
},staticRenderFns: []}

/***/ }),
/* 108 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content-panel__header"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('router-link', {
    staticClass: "button",
    attrs: {
      "id": "new-session",
      "to": {
        name: 'new-session'
      }
    }
  }, [_vm._v("New Session")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "content-panel__scroll",
    attrs: {
      "id": "session-list-panel"
    }
  }, [_c('spinner'), _vm._v(" "), _c('error-modal'), _vm._v(" "), _c('div', {
    staticClass: "session-list"
  }, _vm._l((_vm.sessions), function(session, index) {
    return _c('div', {
      staticClass: "session-list__item"
    }, [_c('div', {
      staticClass: "list-col--title"
    }, [_c('p', [_c('a', {
      on: {
        "click": function($event) {
          _vm.openSessionDetail(session.id)
        }
      }
    }, [_vm._v(_vm._s(session.title))])]), _vm._v(" "), _c('p', {
      staticClass: "related"
    }, [_vm._v(_vm._s(session.description))])]), _vm._v(" "), _c('div', {
      staticClass: "list-col--last-updated-on"
    }, [_c('p', [_c('span', {
      staticClass: "date",
      attrs: {
        "title": session.datetime
      }
    }, [_vm._v(_vm._s(session.datetime))])])]), _vm._v(" "), _c('div', {
      staticClass: "list-col--person"
    }, [_vm._v("\n          " + _vm._s(session.facilitator) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "list-col--place"
    }, [_vm._v("\n          " + _vm._s(session.place) + "\n        ")])])
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "content-panel__footer"
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('h3', [_vm._v("SESSIONS")])])
}]}

/***/ }),
/* 109 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ })
]),[48]);


// WEBPACK FOOTER //
// static/js/app.2fce9e54d6ca76de5bf2.js